import React, { FC, ReactNode } from 'react';

import getClassName from 'src/common/utils/getClassName';
import s from './Layout.module.scss';

type BareLayoutProps = {
  children: ReactNode;
  classNameModifier?: string;
};

const BareLayout: FC<BareLayoutProps> = ({ children, classNameModifier }) => (
  <div className={getClassName(s, 'root', classNameModifier)}>
    {children}
  </div>
);

export default BareLayout;
